import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import reduce from 'lodash/reduce';
import {
  GET_DOCUMENTS_LINK_ACTION,
  GET_DOCUMENT_CATEGORIES_DATA,
  GET_DOCUMENT_FORM_DATA,
  GET_DOCUMENT_DETAIL_DATA,
  GET_DOCUMENT_GUIDELINE_DATA,
  GET_DOCUMENT_NOTIFY_DATA,
} from './constants';
import {
  setFilterFormConfig,
  setDocumentFormDataAction,
  setDocumentDetailData,
  setDocumentCategoriesDataAction,
  setDocumentNotifyDataAction,
  setFilterNotifyConfig,
  setDocumentGuidelineDataAction,
  setFilterGuidelineConfig,
} from './actions';
import {
  getDocumentCategories,
  getDocumentsDetailService,
  getDocumentsLinkService,
  getDocumentsListService,
} from '@services/document';
import { loadingRequest, loadingSuccess } from '@stores/global/actions';
import { hasValue, isEmpty } from '@helpers/utils/utils';
import { selDocumentCategoriesData } from './selectors';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal.jsx';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig.js';
import { selectAllProfilesRoles } from '@stores/auth/selectors.js';
import { isAd, isLeader, getChannelNameFromProfiles } from '@helpers/roleUtils';
import { sessionStorageUtils } from '@helpers/sessionStorageUtils.js';

export function* fetchDocumentData({ payload }) {
  let exclusiveStartKeyEncodeURI = '';
  try {
    yield put(loadingRequest());
    const storedAllProfilesRoles = yield select(selectAllProfilesRoles);
    const allProfilesRoles = storedAllProfilesRoles?.length
      ? storedAllProfilesRoles
      : (sessionStorageUtils.getItem('_profiles')?.profiles || []).flatMap(
          (p) => p.roles || [],
        );
    const userIsAd = isAd(allProfilesRoles);
    const userIsLeader = isLeader(allProfilesRoles);
    const { items, exclusiveStartKey } = yield call(
      getDocumentsListService,
      payload,
    );
    yield put(loadingSuccess());

    exclusiveStartKeyEncodeURI = isEmpty(exclusiveStartKey)
      ? ''
      : encodeURI(exclusiveStartKey);
    const isAgency = getChannelNameFromProfiles(allProfilesRoles) === 'Agency';
    console.log(
      'fetchDocumentData userIsAd:',
      userIsAd,
      '| userIsLeader:',
      userIsLeader,
    );
    const filteredItems = !isAgency
      ? items
      : items.filter((item) => {
          if (!item.roles?.length) return false;
          const hasInd = item.roles.includes('IND');
          const hasAd = item.roles.includes('AD');
          const hasLead = item.roles.includes('LEAD');
          if (hasInd && !hasAd && !hasLead) return !userIsAd && !userIsLeader;
          if (!hasInd && hasLead && !hasAd) return !userIsAd && userIsLeader;
          if (!hasInd && !hasLead && hasAd) return userIsAd;
          if (!hasInd && hasLead && hasAd) return userIsAd || userIsLeader;
          if (hasInd && hasLead && !hasAd) return !userIsAd;
          if (hasInd && !hasLead && hasAd) return !userIsLeader || userIsAd;
          if (hasInd && hasLead && hasAd) return true;
          return false;
        });

    yield all([
      put(setDocumentFormDataAction(filteredItems)),
      put(
        setFilterFormConfig({
          ...payload,
          exclusiveStartKey: exclusiveStartKeyEncodeURI,
        }),
      ),
    ]);
  } catch (err) {
    // TODO: handle err business
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}
export function* fetchDocumentNotifyData({ payload }) {
  let exclusiveStartKeyEncodeURI = '';
  try {
    yield put(loadingRequest());
    const storedAllProfilesRoles = yield select(selectAllProfilesRoles);
    const allProfilesRoles = storedAllProfilesRoles?.length
      ? storedAllProfilesRoles
      : (sessionStorageUtils.getItem('_profiles')?.profiles || []).flatMap(
          (p) => p.roles || [],
        );
    const userIsAd = isAd(allProfilesRoles);
    const userIsLeader = isLeader(allProfilesRoles);
    const { items, exclusiveStartKey } = yield call(
      getDocumentsListService,
      payload,
    );
    yield put(loadingSuccess());

    exclusiveStartKeyEncodeURI = isEmpty(exclusiveStartKey)
      ? ''
      : encodeURI(exclusiveStartKey);

    const isAgency = getChannelNameFromProfiles(allProfilesRoles) === 'Agency';
    console.log(
      '[fetchDocumentNotifyData] userIsAd:',
      userIsAd,
      '| userIsLeader:',
      userIsLeader,
    );
    const filteredItems = !isAgency
      ? items
      : items.filter((item) => {
          if (!item.roles?.length) return false;
          const hasInd = item.roles.includes('IND');
          const hasAd = item.roles.includes('AD');
          const hasLead = item.roles.includes('LEAD');
          if (hasInd && !hasAd && !hasLead) return !userIsAd && !userIsLeader;
          if (!hasInd && hasLead && !hasAd) return !userIsAd && userIsLeader;
          if (!hasInd && !hasLead && hasAd) return userIsAd;
          if (!hasInd && hasLead && hasAd) return userIsAd || userIsLeader;
          if (hasInd && hasLead && !hasAd) return !userIsAd;
          if (hasInd && !hasLead && hasAd) return !userIsLeader || userIsAd;
          if (hasInd && hasLead && hasAd) return true;
          return false;
        });

    yield all([
      put(setDocumentNotifyDataAction(filteredItems)),
      put(
        setFilterNotifyConfig({
          ...payload,
          exclusiveStartKey: exclusiveStartKeyEncodeURI,
        }),
      ),
    ]);
  } catch (err) {
    // TODO: handle err business
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}
export function* fetchDocumentGuidelineData({ payload }) {
  let exclusiveStartKeyEncodeURI = '';
  try {
    yield put(loadingRequest());
    const storedAllProfilesRoles = yield select(selectAllProfilesRoles);
    const allProfilesRoles = storedAllProfilesRoles?.length
      ? storedAllProfilesRoles
      : (sessionStorageUtils.getItem('_profiles')?.profiles || []).flatMap(
          (p) => p.roles || [],
        );
    const userIsAd = isAd(allProfilesRoles);
    const userIsLeader = isLeader(allProfilesRoles);
    const { items, exclusiveStartKey } = yield call(
      getDocumentsListService,
      payload,
    );
    yield put(loadingSuccess());

    exclusiveStartKeyEncodeURI = isEmpty(exclusiveStartKey)
      ? ''
      : encodeURI(exclusiveStartKey);

    const isAgency = getChannelNameFromProfiles(allProfilesRoles) === 'Agency';
    console.log(
      '[fetchDocumentGuidelineData] userIsAd:',
      userIsAd,
      '| userIsLeader:',
      userIsLeader,
    );
    const filteredItems = !isAgency
      ? items
      : items.filter((item) => {
          if (!item.roles?.length) return false;
          const hasInd = item.roles.includes('IND');
          const hasAd = item.roles.includes('AD');
          const hasLead = item.roles.includes('LEAD');
          if (hasInd && !hasAd && !hasLead) return !userIsAd && !userIsLeader;
          if (!hasInd && hasLead && !hasAd) return !userIsAd && userIsLeader;
          if (!hasInd && !hasLead && hasAd) return userIsAd;
          if (!hasInd && hasLead && hasAd) return userIsAd || userIsLeader;
          if (hasInd && hasLead && !hasAd) return !userIsAd;
          if (hasInd && !hasLead && hasAd) return !userIsLeader || userIsAd;
          if (hasInd && hasLead && hasAd) return true;
          return false;
        });

    yield all([
      put(setDocumentGuidelineDataAction(filteredItems)),
      put(
        setFilterGuidelineConfig({
          ...payload,
          exclusiveStartKey: exclusiveStartKeyEncodeURI,
        }),
      ),
    ]);
  } catch (err) {
    // TODO: handle err business
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getDocumentDetailData({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getDocumentsDetailService, payload);
    yield put(loadingSuccess());

    yield put(setDocumentDetailData(response));
  } catch (err) {
    // TODO: handle err business
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getDocumentCategoriesData({ payload }) {
  try {
    const categories = yield select(selDocumentCategoriesData);
    if (hasValue(categories)) return;

    yield put(loadingRequest());
    const response = yield call(getDocumentCategories, payload);
    yield put(loadingSuccess());

    let grouped = [];

    if (hasValue(response)) {
      grouped = Object.values(
        reduce(
          response,
          (acc, curr) => {
            if (!acc[curr.lovName]) {
              acc[curr.lovName] = {
                ...curr,
                lovCode: '',
              };
            }
            acc[curr.lovName].lovCode +=
              (acc[curr.lovName].lovCode ? ',' : '') + curr.lovCode;
            return acc;
          },
          {},
        ),
      );
    }

    yield put(setDocumentCategoriesDataAction(grouped));
  } catch (err) {
    // TODO: handle err business
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getDocumentsLinkAction({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getDocumentsLinkService, payload);
    yield put(loadingSuccess());

    if (hasValue(response) && response.link) {
      window.open(response.link);
    }
  } catch (err) {
    // TODO: handle err business
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export default function* documentSaga() {
  yield takeLatest(GET_DOCUMENT_FORM_DATA, fetchDocumentData);
  yield takeLatest(GET_DOCUMENT_NOTIFY_DATA, fetchDocumentNotifyData);
  yield takeLatest(GET_DOCUMENT_GUIDELINE_DATA, fetchDocumentGuidelineData);
  yield takeLatest(GET_DOCUMENT_DETAIL_DATA, getDocumentDetailData);
  yield takeLatest(GET_DOCUMENTS_LINK_ACTION, getDocumentsLinkAction);
  yield takeLatest(GET_DOCUMENT_CATEGORIES_DATA, getDocumentCategoriesData);
}
